// extracted by mini-css-extract-plugin
export default {"listItem":"lR68SbqOqX5BhXSyiXAV","listItemIcon":"JRy5HKeOu50a2ei0S3ls","text":"tYrv_HWSsXVcktQ8b2YW"};